import React, { useRef } from 'react';
import { useDispatch } from "react-redux";
import { digitalOptionCost, smallPrintCost, bigPrintCost } from '../utils/prices';
import { setIsLoading } from "../features/ui/uiSlice";
import { api } from '../utils/api';
export default function CheckoutPopup({ isOpen, onClose, smallPrintCounterSum, bigPrintCounterSum, digitalOptionCounterSum, yearbookOptionCounterSum, email, cards, onSuccess, onFail }) {
  const dispatch = useDispatch();

  const form = useRef();

  const sendOrderEmail = async (orderObj) => {
    const {
      email,
      grandTotal,
      download,
      yearbook,
      smallPrint,
      bigPrint,
      comment
    } = orderObj;

    // Helper to format arrays/objects as requested
    const formatArray = (arr) =>
      arr.length
        ? `[\n${arr.map(item => `"${item}"`).join('\n')}\n]`
        : '[]';

    const formatObject = (obj) => {
      const keys = Object.keys(obj);
      if (!keys.length) return '{}';
      return `{\n${keys.map(k => `"${k}": "${obj[k]}"`).join(',\n')}\n}`;
    };

    const message =
      `🛒 New Photo Order!\n` +
      `📧 Email: ${email}\n` +
      `💰 Total: ${grandTotal}\n` +
      `🖼️ Downloads: ${download.length} Download options: ${formatArray(download)}\n` +
      `📘 Yearbook: ${yearbook.length} Yearbook options: ${formatArray(yearbook)}\n` +
      `🖨️ Small Prints: ${Object.keys(smallPrint).length} Small Prints: ${formatObject(smallPrint)}\n` +
      `🖨️ Big Prints: ${Object.keys(bigPrint).length} Big Prints: ${formatObject(bigPrint)}\n` +
      `✍️ Comment: ${comment || ''}\n\n` +
      `<pre>${JSON.stringify(orderObj, null, 2)}</pre>`;

    const escapeHtml = (text) => text
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
    const [summary, orderDetails] = message.split('\n\n<pre>');
    const html = `${escapeHtml(summary).replace(/\n/g, '<br />')}<pre>${escapeHtml(orderDetails.slice(0, -6))}</pre>`;

    try {
      await api.sendEmail({
        to: 'aabilov@hinksonca.net',
        subject: 'New Photo Order',
        html
      });
      return true;
    } catch (err) {
      return false;
    }
  };

  const sendOrder = async (e) => {
    e.preventDefault();
    onClose();
    dispatch(setIsLoading(true));

    // Gather order data as before
    const usedCardsOnly = cards.filter(obj =>
      obj.yearbookOption === true ||
      obj.downloadOption === true ||
      obj.smallPrintCounter > 0 ||
      obj.bigPrintCounter > 0
    );

    const newCards = usedCardsOnly.map(({ createdAt, _id, owner, isClassPhoto, ...keepAttrs }) => keepAttrs);

    const yearbook = newCards
      .filter(({ yearbookOption }) => yearbookOption === true)
      .map(({ name }) => name);

    const download = newCards
  .filter(({ downloadOption }) => downloadOption === true)
      .map(({ name }) => name);

    const bigPrint = {};
    newCards
      .filter(({ bigPrintCounter }) => bigPrintCounter > 0)
      .forEach(item => bigPrint[item.name] = `order ${item.bigPrintCounter} pcs`);

    const smallPrint = {};
    newCards
      .filter(({ smallPrintCounter }) => smallPrintCounter > 0)
      .forEach(item => smallPrint[item.name] = `order ${item.smallPrintCounter} pcs`);

    const grandTotal = (digitalOptionCounterSum * digitalOptionCost + smallPrintCounterSum * smallPrintCost + bigPrintCounterSum * bigPrintCost);

    // Get comment from form
    const comment = form.current.comment.value;

    // Compose the object to send (same as before)
    const orderObj = {
      grandTotal,
      email,
      comment,
      newCards,
      digitalOptionCounterSum,
      yearbookOptionCounterSum,
      smallPrintCounterSum,
      bigPrintCounterSum,
      download,
      yearbook,
      smallPrint,
      bigPrint
    };

    const ok = await sendOrderEmail(orderObj);
    dispatch(setIsLoading(false));
    if (ok) {
      onSuccess('Great! Your order is being processed. You will receive an email shortly');
    } else {
      onFail();
    }
  };

  const grandTotal = (digitalOptionCounterSum * digitalOptionCost + smallPrintCounterSum * smallPrintCost + bigPrintCounterSum * bigPrintCost);

  return (

    <div className={`popup ${isOpen ? 'popup_opened' : ''}`}>
      <div className='popup__container' >

        <h2 className='popup__title'>Order Summary</h2>
        <table>
          <thead>
            <tr>
              <th>Selected Options</th>
              <th>Quantity</th>
              <th>Price</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Download</td>
              <td>{digitalOptionCounterSum}</td>
              <td>{digitalOptionCost}</td>
              <td>{digitalOptionCounterSum * digitalOptionCost}</td>
            </tr>
            <tr>
              <td>Small Print</td>
              <td>{smallPrintCounterSum}</td>
              <td>{smallPrintCost}</td>
              <td>{smallPrintCounterSum * smallPrintCost}</td>
            </tr>
            <tr>
              <td>Big Print</td>
              <td>{bigPrintCounterSum}</td>
              <td>{bigPrintCost}</td>
              <td>{bigPrintCounterSum * bigPrintCost}</td>
            </tr>
            <tr>
              <th colSpan='3'>Grand Total</th>
              <th>{grandTotal}</th>
            </tr>
          </tbody>
        </table>

        <button type='button' className='popup__close-btn' onClick={onClose} />

        <p>Please transfer {grandTotal} rubles to +7 985 835 7632 (Alexandr A) in SberBank</p>
        <p>Printed Photos are ready within 3-4 days. You can pick them at school's reception</p>
        <p>Photos for download will be sent to this address: {email}</p>

        <form ref={form} onSubmit={sendOrder}>

          <label className='popup__label'>Comment to the order:</label><br />
          <input className='popup__textarea' type='textarea' maxLength={200} rows='2' name='comment' placeholder='Alternative email or question' /><br />

          <input type='submit' width='100%' className='popup__submit-btn' value='Submit Order for Processing' />
        </form>

      </div>
    </div>
  )
}
